export default __webpack_public_path__ + "static/cafe_36052-78abf55a64b16d6405ba16e0a51a9e5a.png";